import { useContext } from 'react';
import useScheduleMeetingsEnabled from '../../meetings/hooks/useScheduleMeetingsEnabled';
import AppToolsContext from '../context/AppToolsContext';

const MeetingsToolEnabled = ({ children }) => {
    const { eventUniqueName } = useContext(AppToolsContext);
    const { isLoading, data: isEnabled } = useScheduleMeetingsEnabled(eventUniqueName);
    return children({ isLoading, isEnabled });
};

export default MeetingsToolEnabled;
